/**
 * Created by amirb on 7/26/15.
 */
define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};

    var lpUtils = require('utils/lpUtils');
    var ViewController = require('web-agent-framework/ViewController');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var SlaChangerListViewController = require('web-agent-viewControllers/SlaChangerListViewController');
    var SlaChangerFooterViewController = require('web-agent-viewControllers/SlaChangerFooterViewController');


    var SlaChangerViewController = ViewController.extend({
        ControllerName: 'SlaChangerViewController',

        LPViewMap: {
            CONTENT: '.lpview_sladropup_content',
            RESTORE_LINK: '.lpview_sla_restore_link',
            SLA_BUTTON: '.lpview_sladropup_button',
            DROP_UP_CONTAINER: '.lpview_sla_changer_dropup',
            HEADER: '.lpView_sla_header_content',
            CUSTOM_PLACEHOLDER: '.custom_sla_placeholder',
            PREDEFINED_PLACEHOLDER: '.lpview_predifend_sla_list_placeholder',
            SLA_CHANGER_BUTTON_CONTENT: '.lpview_sla_changer_button_content'
        },

        initialize : function (constructorData) {
            this.chatId = constructorData.chatId;
            this.initView();
        },

        events: function () {
            this.bindViewEvent({selector : this.LPViewMap.SLA_BUTTON, DOMEvent : "click", callback : this.toggleslaChangerMenu});
            this.bindViewEvent({selector : this.LPViewMap.CONTENT, DOMEvent : "blur", callback : this.hideSlaDropUp, ignoreChildBlur: true, includeSelf: true});
            this.bindViewEvent({selector :  this.LPViewMap.RESTORE_LINK, DOMEvent : "click", callback : this.restoreSla});
            this.updateChatId(this.chatId);
        },

        render: function () {

        }
    });

    SlaChangerViewController.prototype.updateChatId = function(chatId) {
        var agentParticipatingInConversationKey;
        if (chatId) {
            var mainDialog = lpTag.WebAgent.logicController.getMainDialogOfConversation(this.chatId);
            agentParticipatingInConversationKey = lpTag.WebAgent.logicController.getLoggedInAgentRolePathInConversationDialog(this.chatId, mainDialog.dialogId);
            if (this.chatId) {
                this.unbindModel({modelPath: 'chats.' + this.chatId + '.chatInfo.activeDialogId', callback: this.toggleVisibility});                
                this.unbindModel({modelPath: 'chats.' + this.chatId + '.chatInfo.manualETTR', callback: this.toggleManualSlaIsActive});
                this.unbindModel({modelPath: 'chats.' + this.chatId + '.chatInfo.SlaTexts.text', callback: this.setMessagingSla, context: this});
                this.unbindModel({modelPath: agentParticipatingInConversationKey, callback: this.toggleVisibility, context: this});
            }
            this.chatId = chatId;
            if (this.slaChargerListView) {
                this.slaChargerListView.updateChatId(chatId);
            }
            if (this.slaChargerFooterView) {
                this.slaChargerFooterView.updateChatId(chatId);
            }
            this.bindModel({modelPath: 'chats.' + this.chatId + '.chatInfo.activeDialogId', callback: this.toggleVisibility});
            this.bindModel({modelPath: 'chats.' + this.chatId + '.chatInfo.manualETTR', callback: this.toggleManualSlaIsActive});
            this.bindModel({modelPath: 'chats.' + this.chatId + '.chatInfo.SlaTexts.text', callback: this.setMessagingSla, context: this});
            this.bindModel({modelPath: agentParticipatingInConversationKey, callback: this.toggleVisibility, context: this});
        }
    };

    SlaChangerViewController.prototype.initView = function () {

        var listTemplate = require('web-agent-templates/LP_sla_changer.html');
        // var listTemplate = lpUtils.loadResource('web-agent-templates/LP_sla_changer.html');
        listTemplate = this.injectTextDefaults(listTemplate,{slaHeaderMsg: agentLEManager.translateLE('LEWebAgent.MANUAL_SLA_Header'), slaRestore: agentLEManager.translateLE('LEWebAgent.MANUAL_SLA_Restore')});
        this.createView({template: listTemplate});
        createSlaList(this);
        createSlaFooter(this);
        this.visible = false;
        this.lpHide(this.LPViewMap.CONTENT);

        function createSlaList(context) {
            var view = context.getFirstElement(context.LPViewMap.DROP_UP_CONTAINER);
            context.slaChargerListView = new SlaChangerListViewController({
                modelController: context.modelController,
                view: view,
                closeDropUp: function () {
                    context.hideSlaDropUp.call(context);
                },
                chatId: context.chatId
            });
            context.addViewController({viewController: context.slaChargerListView, target: context.LPViewMap.PREDEFINED_PLACEHOLDER});
        }
        function createSlaFooter(context) {
            context.slaChargerFooterView = new SlaChangerFooterViewController({
                modelController: context.modelController,
                closeDropUp: function () {
                    context.hideSlaDropUp.call(context);
                },
                chatId: context.chatId,
                lostFocusCallback: context.setFocus.bind(context),
                slaChangerSubmit: function () {
                    context.submit.call(context);
                }
            });
            context.addViewController({viewController: context.slaChargerFooterView, target: context.LPViewMap.CUSTOM_PLACEHOLDER});
        }
    };

    SlaChangerViewController.prototype.submit = function () {
        if (this.slaChargerListView && this.slaChargerListView.listViewVC && this.slaChargerListView.listViewVC.clearSelection) {
            this.slaChargerListView.listViewVC.clearSelection();
        }
    };

    SlaChangerViewController.prototype.restoreSla = function(){
        this.hideSlaDropUp();
        this.modelController.restoreManualSla(this.chatId);
        this.toggleManualSlaIsActive({ newValue: 0 }); // set sla to not active
    };

    SlaChangerViewController.prototype.toggleVisibility = function() {
        this.isEnabled = this.getEnableStatus();

        var slaChangerView = this.getFirstElement(this.LPViewMap.DROP_UP_CONTAINER);
        if (this.isEnabled){
            this.removeClass(slaChangerView, 'disabled');
        } else {
            this.addClass(slaChangerView, 'disabled');
        }

        this.toggleManualSlaIsActive({newValue: this.getModelParam('chats.' + this.chatId +'.chatInfo.manualETTR')});
        this.setMessagingSla();
    };

    SlaChangerViewController.prototype.getEnableStatus = function(){
        var mainDialog = lpTag.WebAgent.logicController.getMainDialogOfConversation(this.chatId);
        return this.getModelParam('chats.' + this.chatId + '.chatInfo.messagingState') === lpTag.WebAgent.logicController.conversationStates.OPEN && // Is the conversation open
            mainDialog.state === lpTag.WebAgent.logicController.conversationStates.OPEN && // is the main dialog active
            (lpTag.WebAgent.logicController.isAcceptedEngagementByChatId(this.chatId) || // Is it my conversation
            lpTag.WebAgent.logicController.isLoggedInAgentManagerParticipant(this.chatId, mainDialog.dialogId)); // Am I a participating manager in the main dialog
    };

    SlaChangerViewController.prototype.toggleManualSlaIsActive = function(data){
        var slaChangerView = this.getFirstElement(this.LPViewMap.DROP_UP_CONTAINER);
        if (data && typeof data.newValue !== 'undefined') {
            if(this.isEnabled && data.newValue > 0){
                this.addClass(slaChangerView, 'active');
            } else {
                this.removeClass(slaChangerView, 'active');
            }
        }
    };

    SlaChangerViewController.prototype.toggleslaChangerMenu = function (e) {
        if (this.isEnabled && !this.visible) {
            this.showSlaDropUp();
        } else {
            this.hideSlaDropUp();
        }

    };

    SlaChangerViewController.prototype.hideSlaDropUp = function (e) {
        if (this.slaChargerFooterView) {
            this.slaChargerFooterView.clearInputBox();
        }
        this.lpHide(this.LPViewMap.CONTENT);
        this.visible = false;
    };

    SlaChangerViewController.prototype.showSlaDropUp = function () {
        this.lpShow(this.LPViewMap.CONTENT);
        this.visible = true;
        this.setFocus();
    };

    SlaChangerViewController.prototype.setFocus = function () {
        this.focus(this.LPViewMap.CONTENT);
    };

    SlaChangerViewController.prototype.setMessagingSla = function () {
        var text = '';
        if (this.isEnabled && this.chatId) {
            text = this.getModelParam('chats.' + this.chatId + '.chatInfo.SlaTexts.text');
        }
        if (this.chatId) {
            this.getFirstElement(this.LPViewMap.SLA_CHANGER_BUTTON_CONTENT).innerHTML = text;
        }
    };

    return SlaChangerViewController;

});
